import css from './frame.module.scss';

import { memo } from 'react';

import Preloader from '../Preloader';

const FramePreloader = () => {
  return <Preloader className={css.preloader} />;
};

export default memo(FramePreloader);
